import { X } from "lucide-react";

// Modules object for setting up the Quill editor
export const modules = (toolbarId: string) => ({
	toolbar: {
		container: `#${toolbarId}`,
		handlers: {},
	},
	history: {
		delay: 500,
		maxStack: 100,
		userOnly: true,
	},
});

// Formats objects for setting up the Quill editor
export const formats = ["header", "font", "size", "bold", "italic", "underline", "list", "bullet"];

interface QuillToolbarProps {
	toolbarId?: string;
	toggleEditorVisibility?: () => void;
}

// Quill Toolbar component
export const QuillToolbar = ({ toolbarId, toggleEditorVisibility }: QuillToolbarProps) => {
	return (
		<>
			{toolbarId !== undefined && (
				<div id={toolbarId} className="flex">
					<span className="ql-formats">
						<button type="button" className="ql-bold" />
						<button type="button" className="ql-italic" />
						<button type="button" className="ql-underline" />
						<button type="button" className="ql-list" value="bullet" />
					</span>
					{toggleEditorVisibility && (
						<button
							type="button"
							onClick={toggleEditorVisibility}
							className="ml-auto cursor-pointer p-2 text-black"
							aria-label="Close editor"
						>
							<X className="size-4" />
						</button>
					)}
				</div>
			)}
		</>
	);
};
export default QuillToolbar;
